import $ from 'jquery';

function toggleMobileNav() {
  $('.navigation-mobile-list').toggleClass('active');
  $('.mobile-browse-container').removeClass('active');
}

function toggleMobileSearch() {
  $('.mobile-browse-container').toggleClass('active');
  $('.navigation-mobile-list').removeClass('active');
}

function toggleMobileNavItemsFadeStatus(e) {
  const navItems = $('.mobile-nav-item');
  const target = $(e.target).closest(navItems);

  if (target.hasClass('active')) {
    navItems.removeClass('fade');
    target.removeClass('active');
  } else {
    navItems.not(target).addClass('fade');
    target.addClass('active').removeClass('fade');
  }
}

function closeMenu({ target }) {
  const $dropdown = $('.nav-item.dropdown.active, .navigation-desktop-mega.active');
  const $navTarget = $(target).parent('.nav-item, .mega-nav-dropdown-item, .mega-nav-item');
  if (($dropdown.length > 0) && ($navTarget.length === 0)) {
    $dropdown.toggleClass('active');
  }
}

export default class Navigation {
  constructor({ el }) {
    this.$el = $(el);
    this.body = $(document.body);
    $(window).on('click', event => closeMenu(event));
    this.desktopNav = $('[data-desktop-nav]');
    this._bindEvents();
  }

  _bindEvents() {
    this.events = [
      $('.navigation-desktop .dropdown > a', this.$el).on('click.navigation', e => this.toggleMenu(e)),
      $('.navigation-mobile .dropdown > a', this.$el).on('click.navigation', e => this.toggleMenu(e)),
      $('.mobile-nav-item.navigate > a', this.$el).on('click.navigation', e => toggleMobileNav(e)),
      $('.mobile-nav-item.browse > a', this.$el).on('click.navigation', e => toggleMobileSearch(e)),
      $('.mobile-nav-item > a', this.$el).on('click.navigation', e => toggleMobileNavItemsFadeStatus(e)),
      $(window).on('click.navigation', e => closeMenu(e)),
    ];
  }

  _unbindEvents() {
    if (this.events) {
      this.events.forEach(event => event.off('.navigation'));
    }
  }

  // Toggle desktop nav items
  toggleMenu(e) {
    const a = $(e.currentTarget);
    const dropdown = a.parent('.dropdown');
    const handle = dropdown.data('handle');
    const megaDropdown = a.parent('.nav-item-meganav');
    this.$megaMenus = $('.navigation-desktop-mega');
    this.$megaMenu = $(`.navigation-desktop-mega[data-parent="${handle}"]`);
    const megaMenuHeight = this.$megaMenu.outerHeight();

    e.preventDefault();

    dropdown.toggleClass('active');
    dropdown.siblings('.dropdown').removeClass('active');
    dropdown.find('.dropdown-nav .dropdown').removeClass('active');

    this.$megaMenus.removeClass('active').css('height', '');

    if (megaDropdown.hasClass('active')) {
      this.$megaMenu.toggleClass('active').css('height', megaMenuHeight);
    } else {
      this.$megaMenu.removeClass('active').css('height', '');
    }

    $(window).resize(() => {
      if ((document.documentElement.offsetWidth < 768) && megaDropdown.hasClass('active')) {
        this.$megaMenus.removeClass('active');
        dropdown.toggleClass('active');
      }
    }).trigger('resize');

    this.adjustSimpleNavPosition();
  }

  // Adjust desktop nav item position
  adjustSimpleNavPosition() {
    const navWidth = this.desktopNav.width();

    $('.navigation-desktop > .dropdown').each((index, item) => {
      this.$item = $(item);

      if (!this.$item.hasClass('nav-item-meganav')) {
        const itemOffset = this.$item.offset();

        // +218 to make sure second tier nav stays to the left as long as possible
        if (this.$item.find('.second-tier').length && ((itemOffset.left + 218) > navWidth) && ($(window).width() < (navWidth + 436))) {
          this.$item.find('.second-tier').addClass('adjust-right');
        } else if (this.$item.find('.second-tier').length) {
          this.$item.find('.second-tier').removeClass('adjust-right');
        }

        // +436 to make sure third tier nav stays to the left as long as possible
        if (this.$item.find('.third-tier').length && ((itemOffset.left + 436) > navWidth) && ($(window).width() < (navWidth + 872))) {
          this.$item.find('.third-tier').addClass('adjust-right');
        } else if (this.$item.find('.third-tier').length) {
          this.$item.find('.third-tier').removeClass('adjust-right');
        }
      }
    });
  }
}
